/* eslint no-prototype-builtins: 0 */

import PropTypes from 'prop-types';
import { isValidElement, Component } from 'react';
import RequestStatus from '../data/models/RequestStatus';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LoadingStateWrapper extends Component {
  isLoading() {
    if (this.props.status instanceof Array) {
      return this.props.status.some(status => {
        return status.pending || this.props.showLoadingIfUnfetched && status.uninitialized;
      });
    }
    return this.props.status.pending || this.props.showLoadingIfUnfetched && this.props.status.uninitialized;
  }
  isUnfetched() {
    if (this.props.status instanceof Array) {
      return this.props.status.some(status => status.uninitialized);
    }
    return this.props.status.uninitialized;
  }
  isError() {
    if (this.props.status instanceof Array) {
      return this.props.status.some(status => status.failed);
    }
    return this.props.status.failed;
  }
  isLoaded() {
    if (this.props.status instanceof Array) {
      return this.props.status.every(status => status.succeeded || status.warning);
    }
    return this.props.status.succeeded || this.props.status.warning;
  }
  renderError() {
    if (typeof this.props.error === 'string') {
      return /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: this.props.error
      });
    } else if ( /*#__PURE__*/isValidElement(this.props.error)) {
      return this.props.error;
    } else if (this.props.error instanceof Object && this.props.error.hasOwnProperty('title') && this.props.error.hasOwnProperty('body')) {
      return (
        /*#__PURE__*/
        // @ts-expect-error Net new type error due to upgrade to TypeScript 5.1
        _jsx(Alert, {
          type: "danger",
          titleText: this.props.error.title,
          children: this.props.error.body
        })
      );
    }
    throw new Error('Loading state wrapper was passed a bad error property.');
  }
  renderLoading() {
    if (this.props.loadingElement) {
      return this.props.loadingElement;
    }
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 200
    });
  }
  render() {
    if (this.isError()) {
      return this.renderError();
    } else if (this.isLoading()) {
      return this.renderLoading();
    } else if (this.isUnfetched()) {
      return null;
    } else if (this.isLoaded()) {
      return this.props.children;
    }
    throw new Error('Loading state wrapper was passed a bad status.');
  }
}
LoadingStateWrapper.propTypes = {
  status: PropTypes.oneOfType([PropTypes.instanceOf(RequestStatus), PropTypes.arrayOf(PropTypes.instanceOf(RequestStatus))]).isRequired,
  loadingElement: PropTypes.element,
  error: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    body: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
  })]).isRequired,
  children: PropTypes.node,
  showLoadingIfUnfetched: PropTypes.bool
};
LoadingStateWrapper.defaultProps = {
  showLoadingIfUnfetched: false
};